import { createSlice } from '@reduxjs/toolkit'
import { filterRecommendations } from 'utils/screens/enroll-card'

const initialState = {
  cardEligibility: null,
  otherCardEligibilities: null,
  recommendations: null,
  cardApplication: null,
  card: null,
  toastMessage: null,
  xoPPDCContent: null,
}

const enrollCardSlice = createSlice({
  name: 'enrollCard',
  initialState,
  reducers: {
    initEnrollCardPreEligibilityReducer(state, action) {
      const { cardEligibility, loyaltyStatus, recommendations } = action.payload
      state.cardEligibility = cardEligibility
      state.loyaltyStatus = loyaltyStatus
      state.recommendations = filterRecommendations(recommendations)
    },
    initEnrollCard(state, action) {
      const { cardEligibility, otherCardEligibilities, recommendations, applyCard } = action.payload
      state.cardEligibility = cardEligibility
      state.otherCardEligibilities = otherCardEligibilities
      state.recommendations = filterRecommendations(recommendations)
      state.cardApplication = applyCard
    },
    updateCard(state, action) {
      const { card } = action.payload
      state.card = card
    },
    resetEnrollCard(state) {
      Object.assign(state, {
        ...initialState,
      })
    },
    setToastMessage(state, action) {
      state.toastMessage = action.payload?.toastMessage
    },
    clearToastMessage(state) {
      state.toastMessage = null
    },
    setXoPPDCContent(state, action) {
      const { recommendations, offerUnitId, selectedOfferId, isOfferValid, xt, xe, instrumentationData, apiError } = action.payload
      state.xoPPDCContent = {
        recommendations,
        offerUnitId,
        selectedOfferId,
        isOfferValid,
        xt,
        xe,
        instrumentationData,
        apiError
      }
    },
  },
})

export const selectCardEligibility = (state) => state.enrollCard?.cardEligibility
export const selectOtherCardEligibilities = (state) => state.enrollCard?.otherCardEligibilities
export const selectRecommendations = (state) => state.enrollCard?.recommendations
export const selectCardApplication = (state) => state.enrollCard?.cardApplication
export const selectToastMessage = (state) => state.enrollCard?.toastMessage
export const selectXoPPDCContent = (state) => state.enrollCard?.xoPPDCContent
export const selectLoyaltyStatus = (state) => state.enrollCard?.loyaltyStatus

export const {
  initEnrollCard,
  initEnrollCardPreEligibilityReducer,
  updateCard,
  resetEnrollCard,
  setToastMessage,
  clearToastMessage,
  setXoPPDCContent,
} = enrollCardSlice.actions

export default enrollCardSlice.reducer
